const module = { name: 'global/utils/functionUtils', exports: {} }; const exports = module.exports;



const n = () => { }
function noopObj(sourceObj, props) {
    sourceObj = sourceObj || {};
    if (typeof props === 'string') {
        props = Array.from(arguments);
        props.shift();
    }
    else if (!Array.isArray(props)) {
        return sourceObj;
    }
    props.forEach(name => sourceObj[name] = noopFn(sourceObj[name]));
    return sourceObj;
}
function noopFn(fn) {
    return typeof fn === 'function' ? fn : n;
}
module.exports = {
    noop() {
        return arguments.length > 1 ? noopObj.apply(this, arguments) : noopFn.apply(this, arguments);
    }
};
export default module.exports;